import { render } from "./ClientDeleteModal.vue?vue&type=template&id=2e20f41d"
import script from "./ClientDeleteModal.vue?vue&type=script&lang=js"
export * from "./ClientDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__